import { wrapMethodsWithLogging } from "components/helpers/ErrorHandlingHelpers";
import BaseApiRepository from "repositories/api/BaseApiRepository";

class Repository {

    static async getGroupsAsync() {
        return await BaseApiRepository.getAsync('pcs/groups');
    }

    static async getGroupAsync(id:number) {
        return await BaseApiRepository.getAsync(`pcs/group/${id}`);
    }

    static async setGroupAsync(obj:any) {
        return await BaseApiRepository.putAsync('pcs/group', obj);
    }

    static async deleteGroupAsync(obj:any) {
        return await BaseApiRepository.deleteAsync('pcs/group', obj);
    }

    static async getGroupEvaluationsAsync(id:number) {
        return await BaseApiRepository.getAsync(`pcs/group/${id}/evaluations`);
    }

    static async setGroupEvaluationAsync(obj:any) {
        return await BaseApiRepository.putAsync(`pcs/group/evaluation`, obj);
    }

    static async deleteGroupEvaluationAsync(obj: any) {
        return await BaseApiRepository.deleteAsync(`pcs/group/evaluation`, obj);
    }

    static async getGroupEvaluationAsync(id:number, shipSize:string) {
        return await BaseApiRepository.getAsync(`pcs/group/${id}/evaluation/${shipSize}`);
    }

    static async getGroupLocationDetailsAsync(id:number) {
        return await BaseApiRepository.getAsync(`pcs/group/${id}/location-details`);
    }

    static async setGroupLocationDetailsAsync(obj:any) {
        return await BaseApiRepository.putAsync(`pcs/group/location-details`, obj);
    }

    static async getShipSizesAsync() {
        return await BaseApiRepository.getAsync('pcs/types/ship-sizes');
    }

    static async searchAreaAsync(obj: any) {
        return await BaseApiRepository.postAsync('pcs/search/by-area', obj);
    }

    static async searchGroupsGeometriesAsync(obj:any) {
        return await BaseApiRepository.postAsync('pcs/groups/geometries/search', obj);
    }

    static async getLocationSpecialReasonTypesAsync() {
        return await BaseApiRepository.getAsync('pcs/types/location-special-reason');
    }
};

wrapMethodsWithLogging(Repository);

export default Repository;
